import PresentationQuoteDrawer from './PresentationQuoteDrawer'
export default PresentationQuoteDrawer

export * from './PresentationQuoteDrawer'
